import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import * as permissions from '../lib/permissions';

export function useOperatorPermissions() {
  const { operator } = useAuth();

  return useMemo(
    () => ({
      operator,
      canViewUsage: permissions.canViewUsage(),
      canViewBilling: permissions.canViewBilling(),
      canReconcilePayment: permissions.canReconcilePayment(),
      canViewModels: permissions.canViewModels(),
      canEditModels: permissions.canEditModels(),
      canManageAgents: permissions.canManageAgents(),
      canRevokeSessions: permissions.canRevokeSessions(),
      canPatchUser: permissions.canPatchUser(),
      canViewOperatorAudit: permissions.canViewOperatorAudit(),
      canViewSecurityAudit: permissions.canViewSecurityAudit(),
      canManageTeam: permissions.canManageTeam(),
      canInstagramRedact: permissions.canInstagramRedact(),
      canViewInstagram: permissions.canViewInstagram(),
      canViewWorkspaces: permissions.canViewWorkspaces(),
      canViewTelegramBusiness: permissions.canViewTelegramBusiness(),
      canManageEconomics: permissions.canManageEconomics(),
      permissionDeniedHint: permissions.PERMISSION_DENIED_HINT,
    }),
    [operator],
  );
}
